module.exports = __webpack_public_path__ + "static/education-107e734c37d9222659bc874e50021cf1.jpg";